<div class="footer-logged-out">
  <div class="row align-items-center justify-content-between">
    <ftr-logo [theme]="logoThemes.White" />
    <ftr-footer-help-links />
  </div>
</div>
